export function sendClickNlog(code: string) {
    window.ntm?.push({
        event: 'click',
        nlogEvt: {
            click_area: code, // eslint-disable-line @typescript-eslint/naming-convention
        },
    })
}
